var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado"}},[(!_vm.$vuetify.breakpoint.xs)?[_c('desktop',{attrs:{"listadoDeducciones":_vm.listadoDeducciones}})]:[_c('mobile',{attrs:{"listadoDeducciones":_vm.listadoDeducciones}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }